import { render, staticRenderFns } from "./AgroIAChatPanel.vue?vue&type=template&id=47317808"
import script from "./AgroIAChatPanel.vue?vue&type=script&lang=js"
export * from "./AgroIAChatPanel.vue?vue&type=script&lang=js"
import style0 from "./AgroIAChatPanel.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports